module.exports = __webpack_public_path__ + "img/TECNOLOGIA-S-CROSS-2.377ae098.jpg";